'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var styledComponents = require('../common/styledComponents.js');
var SpinningInner = require('../../../../../core/Spin/SpinningInner.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { spinTriggerImage: spinTrigger } = coreRenderer.mappingAssets;
const SpinTrigger = ({
  disabled = false,
  height = 80,
  width = 80,
  imageStyle,
  image,
  loading,
  onStartSpinning
}) => {
  const _a = image || {}, { src, googleImageParams } = _a, restImage = __objRest(_a, ["src", "googleImageParams"]);
  if (disabled)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: loading ? /* @__PURE__ */ jsxRuntime.jsx(SpinTriggerWrapper, {
      width: 60,
      height: 60,
      children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {
        size: 60,
        transform: 30,
        color: "white"
      })
    }) : /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(SpinTriggerWrapper, {
        width,
        height,
        children: /* @__PURE__ */ jsxRuntime.jsx(SpinImg, __spreadProps(__spreadValues({}, restImage), {
          src: coreRenderer.getImageUrlFromGoogleUserContent(src, googleImageParams) || spinTrigger,
          onClick: onStartSpinning,
          imageStyle,
          alt: ""
        }))
      })
    })
  });
};
const SpinTriggerWrapper = styled__default["default"].div(
  ({ width, height }) => `
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: ${width}px;
height: ${height}px;
max-width: 25%;
max-height: 25%;
`
);
const SpinImg = styled__default["default"](styledComponents.NonDraggableImage)(
  ({ imageStyle }) => `
cursor: pointer;
transition: 0.3s all;
width: 100%;

${coreRenderer.getStyle(imageStyle)}
`
);

exports.SpinTrigger = SpinTrigger;
